import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
    selector: 'app-scoring-tooltip',
    templateUrl: './scoring-tooltip.component.html',
    styleUrls: ['./scoring-tooltip.component.scss'],
    standalone: false,
})
export class ScoringTooltipComponent implements ICellRendererAngularComp {
    public params!: ICellRendererParams;

    tooltipMetrics: { [key: string]: number };

    constructor() {}

    agInit(params: ICellRendererParams): void {
        this.params = params;
        this.tooltipMetrics = this.params.data.criteriaJson;
    }

    refresh(input: ICellRendererParams) {
        return true;
    }
}
